(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.m-section-header');
      this.megamenu = document.querySelector("mega-menu");
      this.navBar = this.querySelector('.m-header__nav');
      this.headerTop = this.querySelector('.m-header__top-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerMenuIcon = this.querySelector('.m-header-menu-icon');
      this.headerBounds = {};
      this.headerTop = this.querySelector('.m-header__top-wrapper');

      this.setHeaderHeight();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('m-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.headerMenuIcon.addEventListener("click", this.toggleMenuBar.bind(this));

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    toggleMenuBar() {
      if (this.headerMenuIcon.classList.contains('is-open')) {
        this.headerMenuIcon.classList.remove('is-open');
      } else {
        this.headerMenuIcon.classList.add('is-open');
      }
      if (this.navBar.classList.contains('nav-bar-hidden')) {
        this.navBar.classList.remove('nav-bar-hidden');
        this.headerTop.classList.remove('nav-bar-hidden');
      } else {
        this.navBar.classList.add('nav-bar-hidden');
        this.headerTop.classList.add('nav-bar-hidden');
        
      }
    }

    setHeaderTopHeight () {
      document.documentElement.style.setProperty('--header-height', `${this.headerTop.offsetHeight}px`);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      document.documentElement.style.setProperty('--nav-bar-height', `${this.navBar.offsetHeight}px`);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.documentElement.classList.add('scrolled-past-header');
        this.setHeaderTopHeight();
        if (!this.headerMenuIcon.classList.contains('is-open')) {
          this.navBar.classList.add('nav-bar-hidden');
          this.headerTop.classList.add('nav-bar-hidden');
        }
        this.megamenu && this.megamenu.init();
        this.megamenu && this.megamenu.close();
        this.headerIsAlwaysSticky && this.megamenu && this.megamenu.setAttribute("data-toggle", "true");
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.documentElement.classList.remove('scrolled-past-header');
        this.navBar.classList.remove('nav-bar-hidden');
        this.headerTop.classList.remove('nav-bar-hidden');
        this.headerMenuIcon.classList.remove('is-open');
        this.setHeaderHeight();
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.megamenu && this.megamenu.removeAttribute("data-toggle");
      this.header.classList.add('m-section-header-hidden', 'm-section-header-sticky');
      document.documentElement.classList.add('m-section-header-hidden');
      this.closeLocalizationForm();
      this.closePredictiveSearch();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.megamenu && this.megamenu.setAttribute("data-toggle", "true");
      this.header.classList.add('m-section-header-sticky', 'animate');
      this.header.classList.remove('m-section-header-hidden');
      document.documentElement.classList.remove('m-section-header-hidden');
    }

    reset() {
      if (this.megamenu && this.megamenu.openDefault && this.megamenu.template === 'index') {
        this.megamenu && this.megamenu.open();
      }
      if (this.currentScrollTop === 0) {
        this.megamenu && this.megamenu.removeAttribute("data-toggle");
      }
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('m-section-header-hidden', 'm-section-header-sticky', 'animate');
    }

    closePredictiveSearch() {
      this.predictiveSearch = this.predictiveSearch || this.header.querySelector('predictive-search');
      this.predictiveSearch.close(false);
    }

    closeLocalizationForm() {
      this.localization = this.localization || this.header.querySelectorAll('localization-form');
      this.localization.forEach(localization => localization.hidePanel());
    }
  }
  customElements.define('sticky-header', StickyHeader);

  const abcDiv = document.querySelector('.m-megamenu__navigation-container.m-foxkit-menu-desktop .m-megamenu__menu');
  const targetDiv = document.getElementById('m-megamenu-mobile-sections--15556763484231__729ed7ff-cd70-41ab-97b7-db284c5764d5');
  const pqrDiv = document.querySelector('.m-header__menu-custom-html ul');
    
    if (pqrDiv) {
        abcDiv.appendChild(pqrDiv);
       targetDiv.appendChild(pqrDiv.cloneNode(true));
    }
  

  } catch(e) { console.error(e); }
})();
})();
